import React from 'react';
import '../../App.css';

export default function Requisitos() {
    return <>
        <body className='requisitos'>
            <h1 className='title'>REQUISITOS</h1>
            <p className='texto'>
                - Gestante,  no cio ou lactante n&atilde;o pode doar
            </p>

            <p className='texto'>
                - Fiv e Felv testado e negativo
            </p>

            <p className='texto'>
                - Peso M&iacute;nimo: Cachorro (25 kg) e gato (3,5 kg)
            </p>

            <p className='texto'>
                - Idade: Cachorro (1 a 8 anos) e gato (1 a 7 anos)
            </p>

            <p className='texto'>
                - Preferencialmente animal d&oacute;cil e de f&aacute;cil manejo
            </p>
        </body>
    </>;
}